var _slicedToArray = function () {
  function sliceIterator(arr, i) {
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
      for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
        _arr.push(_s.value);
        if (i && _arr.length === i) break;
      }
    } catch (err) {
      _d = true;
      _e = err;
    } finally {
      try {
        if (!_n && _i["return"]) _i["return"]();
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
  return function (arr, i) {
    if (Array.isArray(arr)) {
      return arr;
    } else if (Symbol.iterator in Object(arr)) {
      return sliceIterator(arr, i);
    } else {
      throw new TypeError("Invalid attempt to destructure non-iterable instance");
    }
  };
}();
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
import FunctionTree from 'function-tree';
import Module from './Module';
import DebuggerProvider from './providers/Debugger';
import GetProvider from './providers/Get';
import ModuleProvider from './providers/Module';
import { cleanPath, ensurePath, forceSerializable, getModule, getProviders, getStateChanges, isDeveloping, isObject, isSerializable, throwError } from './utils';

/*
  The controller is where everything is attached. The devtools
  is attached directly. Also a top level module is created.
  The controller creates the function tree that will run all sequences,
  based on top level providers and providers defined in modules
*/

var BaseController = function (_FunctionTree) {
  _inherits(BaseController, _FunctionTree);
  function BaseController(rootModule, options, functionTreeOptions) {
    _classCallCheck(this, BaseController);
    var _this = _possibleConstructorReturn(this, (BaseController.__proto__ || Object.getPrototypeOf(BaseController)).call(this, {}, functionTreeOptions));
    var Model = options.Model,
      _options$devtools = options.devtools,
      devtools = _options$devtools === undefined ? null : _options$devtools,
      _options$stateChanges = options.stateChanges,
      stateChanges = _options$stateChanges === undefined ? typeof window !== 'undefined' && window.CEREBRAL_STATE : _options$stateChanges,
      _options$throwToConso = options.throwToConsole,
      throwToConsole = _options$throwToConso === undefined ? true : _options$throwToConso,
      _options$preventIniti = options.preventInitialize,
      preventInitialize = _options$preventIniti === undefined ? false : _options$preventIniti,
      _options$returnSequen = options.returnSequencePromise,
      returnSequencePromise = _options$returnSequen === undefined ? false : _options$returnSequen,
      _options$noRethrow = options.noRethrow,
      noRethrow = _options$noRethrow === undefined ? false : _options$noRethrow;
    var getSequence = _this.getSequence;
    var getSequences = _this.getSequences;
    _this.getSequence = function () {
      throwError('You are grabbing a sequence before controller has initialized, please wait for "initialized" event');
    };
    _this.getSequences = function () {
      throwError('You are grabbing sequences before controller has initialized, please wait for "initialized" event');
    };
    _this.throwToConsole = throwToConsole;
    _this.noRethrow = noRethrow;
    _this.returnSequencePromise = returnSequencePromise;
    _this.devtools = devtools;
    _this.Model = Model;
    _this.configure(rootModule);
    if (!preventInitialize) {
      _this.emit('initialized:model');
    }
    _this.contextProviders = Object.assign(_this.contextProviders, getProviders(_this.module), {
      app: _this,
      controller: _this,
      // To be deprecated
      get: GetProvider,
      state: _this.model.StateProvider(_this.devtools),
      store: _this.model.StoreProvider && _this.model.StoreProvider(_this.devtools),
      module: ModuleProvider(_this.devtools)
    }, _this.devtools ? {
      debugger: DebuggerProvider(_this.devtools)
    } : {});
    if (stateChanges) {
      Object.keys(stateChanges).forEach(function (statePath) {
        _this.model.set(ensurePath(statePath), stateChanges[statePath]);
      });
    }
    if (_this.devtools) {
      _this.devtools.init(_this);
    }
    if (!_this.devtools && isDeveloping() && typeof navigator !== 'undefined' && /Chrome/.test(navigator.userAgent)) {
      console.warn('You are not using the Cerebral devtools. It is highly recommended to use it in combination with the debugger: https://cerebraljs.com/docs/introduction/debugger.html');
    }
    if (isDeveloping()) {
      _this.on('functionStart', function (execution, functionDetails, payload) {
        try {
          JSON.stringify(payload);
        } catch (e) {
          throwError('The function ' + functionDetails.name + ' in sequence ' + execution.name + ' is not given a valid payload');
        }
      });
      _this.on('functionEnd', function (execution, functionDetails, payload, propsToAdd) {
        if (devtools && devtools.preventPropsReplacement) {
          Object.keys(propsToAdd || {}).forEach(function (key) {
            if (key in payload) {
              throw new Error('Cerebral Devtools - You have activated the "preventPropsReplacement" option and in sequence "' + execution.name + '", before the action "' + functionDetails.name + '", the key "' + key + '" was replaced');
            }
          });
        }
      });
    }
    _this.getSequence = getSequence;
    _this.getSequences = getSequences;
    if (!preventInitialize) {
      _this.emit('initialized');
    }
    return _this;
  }

  /*
    Configures the instance
  */

  _createClass(BaseController, [{
    key: 'configure',
    value: function configure(rootModule) {
      this.module = rootModule instanceof Module ? rootModule.create(this, []) : new Module(rootModule).create(this, []);
      this.model = new this.Model(this);
    }

    /*
      Reconfigures related to hot reloading
    */
  }, {
    key: 'reconfigure',
    value: function reconfigure(rootModule) {
      var _this2 = this;
      if (this.devtools) {
        var existingState = this.model.get();
        this.configure(rootModule);
        var changes = getStateChanges(JSON.parse(this.devtools.initialModelString), existingState, this.model.get());
        changes.forEach(function (change) {
          _this2.model.set(change.path, change.value);
        });
        this.devtools.sendReInit();
        this.flush();
      }
    }

    /*
      Conveniance method for grabbing the model
    */
  }, {
    key: 'getModel',
    value: function getModel() {
      return this.model;
    }

    /*
      Method called by view to grab state
    */
  }, {
    key: 'getState',
    value: function getState(path) {
      var value = this.model.get(ensurePath(cleanPath(path)));
      if (typeof path === 'string' && path.substr(path.length - 2, 2) === '.*') {
        return value ? Object.keys(value) : [];
      }
      return value;
    }

    /*
      Uses function tree to run the array and optional
      payload passed in. The payload will be checkd
    */
  }, {
    key: 'runSequence',
    value: function runSequence(name, sequence) {
      var _this3 = this;
      var payload = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
      if (this.devtools && (!isObject(payload) || !isSerializable(payload))) {
        console.warn('You passed an invalid payload to sequence "' + name + '". Only serializable payloads can be passed to a sequence. The payload has been ignored. This is the object:', payload);
        payload = {};
      }
      if (this.devtools) {
        payload = Object.keys(payload).reduce(function (currentPayload, key) {
          if (!isSerializable(payload[key], _this3.devtools.allowedTypes)) {
            console.warn('You passed an invalid payload to sequence "' + name + '", on key "' + key + '". Only serializable values like Object, Array, String, Number and Boolean can be passed in. Also these special value types:', _this3.devtools.allowedTypes);
            return currentPayload;
          }
          currentPayload[key] = forceSerializable(payload[key]);
          return currentPayload;
        }, {});
      }
      var callback = function callback(error) {
        if (error) {
          var sequencePath = ensurePath(error.execution.name);
          var catchingResult = sequencePath.reduce(function (details, key, index) {
            if (details.currentModule.catch) {
              details.catchingModule = details.currentModule;
            }
            details.currentModule = details.currentModule.modules[key];
            return details;
          }, {
            currentModule: _this3.module,
            catchingModule: null
          });
          if (catchingResult.catchingModule) {
            var _iteratorNormalCompletion = true;
            var _didIteratorError = false;
            var _iteratorError = undefined;
            try {
              for (var _iterator = catchingResult.catchingModule.catch[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
                var _step$value = _slicedToArray(_step.value, 2),
                  errorType = _step$value[0],
                  errorSequence = _step$value[1];
                if (error instanceof errorType) {
                  _this3.runSequence('catch', errorSequence, error.payload);

                  // Throw the error to console even if handling it
                  if (_this3.throwToConsole) {
                    setTimeout(function () {
                      console.log('Cerebral is handling error "' + error.name + ': ' + error.message + '" thrown by sequence "' + error.execution.name + '". Check debugger for more information.');
                    });
                  }
                  return;
                }
              }
            } catch (err) {
              _didIteratorError = true;
              _iteratorError = err;
            } finally {
              try {
                if (!_iteratorNormalCompletion && _iterator.return) {
                  _iterator.return();
                }
              } finally {
                if (_didIteratorError) {
                  throw _iteratorError;
                }
              }
            }
          }

          // If we already catch errors in controller.on('error'), we might not
          // want errors to be thrown again.
          if (!_this3.noRethrow) {
            if (error.execution.isAsync) {
              setTimeout(function () {
                throw error;
              });
            } else {
              throw error;
            }
          }
        }
      };
      if (this.returnSequencePromise) {
        return this.run(name, sequence, payload).catch(callback);
      } else {
        this.run(name, sequence, payload, callback);
      }
    }

    /*
      Returns a function which binds the name/path of sequence,
      and the array. This allows view layer to just call it with
      an optional payload and it will run
    */
  }, {
    key: 'getSequence',
    value: function getSequence(path) {
      var pathArray = ensurePath(path);
      var sequenceKey = pathArray.pop();
      var module = pathArray.reduce(function (currentModule, key) {
        return currentModule ? currentModule.modules[key] : undefined;
      }, this.module);
      var sequence = module && module.sequences[sequenceKey];
      if (!sequence) {
        return;
      }
      return sequence && sequence.run;
    }
  }, {
    key: 'getSequences',
    value: function getSequences(modulePath) {
      var pathArray = ensurePath(modulePath);
      var module = pathArray.reduce(function (currentModule, key) {
        return currentModule ? currentModule.modules[key] : undefined;
      }, this.module);
      var sequences = module && module.sequences;
      if (!sequences) {
        return undefined;
      }
      var callableSequences = {};
      for (var name in sequences) {
        callableSequences[name] = sequences[name].run;
      }
      return callableSequences;
    }
  }, {
    key: 'addModule',
    value: function addModule(path, module) {
      var pathArray = ensurePath(path);
      var moduleKey = pathArray.pop();
      var parentModule = getModule(pathArray, this.module);
      var newModule = module instanceof Module ? module.create(this, ensurePath(path)) : new Module(module).create(this, ensurePath(path));
      parentModule.modules[moduleKey] = newModule;
      if (newModule.providers) {
        Object.assign(this.contextProviders, newModule.providers);
      }
      this.emit('moduleAdded', path.split('.'), newModule);
      this.flush();
    }
  }, {
    key: 'removeModule',
    value: function removeModule(path) {
      var _this4 = this;
      if (!path) {
        console.warn('Controller.removeModule requires a Module Path');
        return null;
      }
      var pathArray = ensurePath(path);
      var moduleKey = pathArray.pop();
      var parentModule = getModule(pathArray, this.module);
      var module = parentModule.modules[moduleKey];
      if (module.providers) {
        Object.keys(module.providers).forEach(function (provider) {
          delete _this4.contextProviders[provider];
        });
      }
      delete parentModule.modules[moduleKey];
      this.emit('moduleRemoved', ensurePath(path), module);
      this.flush();
    }
  }]);
  return BaseController;
}(FunctionTree);
export default BaseController;